import React from 'react';
import styled from 'styled-components';
import Link from '~/components/router/query-encoded-link';
import { Caption } from '@comeon/ui';

const EventNameWrapper = styled.div`
	margin-top: 3px;
`;
const EventLink = styled(Link)`
	&:hover {
		text-decoration: underline;
	}
`;
const EventName = styled(Caption)`
	color: var(--sportsbook-text-supportive);
	word-break: break-word;
`;

type EventNameInfoProps = {
	eventName: string;
	eventLink?: string;
};
const EventNameInfo: React.FC<EventNameInfoProps> = ({ eventName, eventLink }) => {
	return (
		<EventNameWrapper>
			{eventLink ? (
				<EventLink href={eventLink}>
					<EventName data-at="event-name">{eventName}</EventName>
				</EventLink>
			) : (
				<EventName data-at="event-name">{eventName}</EventName>
			)}
		</EventNameWrapper>
	);
};

export default EventNameInfo;
